import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeaderHome from './components/HeaderHome';
import Footer from './components/Footer';
import Maintenance from './pages/Maintenance';
import Home from './pages/Home';
import Tienda from './pages/Tienda';
import Contact from './pages/Contact'; 
import Metodologia from './pages/Metodologia';
import Services from './pages/Services';
import ScrollToTop from './ScrollToTop';
import ValoracionFuncional from './pages/Valoracion_funcional';
import RehabilitacionReadaptacion from './pages/RehabilitacionReadaptacion';
import Fisioterapia from './pages/Fisioterapia';
import EntrernamientoPersonal from './pages/EntrenamientoPersonal';
import Equipo from './pages/Equipo';
import EntrenamientoGrupo from './pages/EntrenamientoGrupo';
import RehabXF from './pages/RehabXF';
import MBZProfesional from './pages/MBZProfesional';
import PreparacionOposiciones from './pages/PreparacionOposiciones';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';
import CookieBanner from './components/CookieBanner';
import CookieSettings from './components/CookieSettings';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const MAINTENANCE_MODE = false;

function App() {
  if (MAINTENANCE_MODE) {
    return <Maintenance />;
  }
  return (
    <Router>
      <CookieBanner />
      <ScrollToTop />
      <Layout />
    </Router>
  );
}

function Layout() {
  const location = useLocation();
  const isHome = location.pathname === '/'; // Comprueba si estás en Home

  return (
    <>
      {/* Header condicional */}
      {isHome ? <HeaderHome /> : <Header />}
      
      {/* Rutas */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} /> 
        <Route path="/metodologia" element={<Metodologia />} />
        <Route path="/tienda" element={<Tienda />} />
        <Route path="/services" element={<Services />} />
        <Route path="/valoracion-funcional" element={<ValoracionFuncional />} />
        <Route path="/rehabilitacion-readaptacion" element={<RehabilitacionReadaptacion />} />
        <Route path="/fisioterapia" element={<Fisioterapia />} />
        <Route path="/entrenamiento-personal" element={<EntrernamientoPersonal />} />
        <Route path="/equipo" element={<Equipo />} />
        <Route path="/entrenamiento-grupal" element={<EntrenamientoGrupo />} />
        <Route path="/mbz-profesional" element={<MBZProfesional />} />
        <Route path="/rehab-xf" element={<RehabXF />} />
        <Route path="/entrenamiento-oposiciones" element={<PreparacionOposiciones />} />
        <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
        <Route path="/configurar-cookies" element={<CookieSettings />} />

      </Routes>

      {/* Footer global */}
      <Footer />
    </>
  );
}

export default App;
